if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('button');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
        }

        if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.style.pointerEvents = 'none';
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const afterAdded = (finalResponse) => {
              try {
                if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
                  window.Shopify.analytics.publish("product_added_to_cart", {
                    cartLine: {
                      merchandise: { id: "gid://shopify/ProductVariant/" + formData.get('id') },
                      quantity: parseInt(formData.get('quantity') || 1, 10)
                    }
                  });
                }
              } catch(e) {}
              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: finalResponse,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(finalResponse);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(finalResponse);
                });
              }
            };

            const cartDrawer = this.cart || document.querySelector('cart-drawer');
            if (response.sections) {
              afterAdded(response);
            } else if (cartDrawer) {
              const sectionIds = cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender().map((s) => s.id).join(',') : 'cart-drawer,cart-icon-bubble';
              fetch(window.location.pathname + '?sections=' + sectionIds)
                .then(r => r.json())
                .then(sectionsResponse => {
                  response.sections = sectionsResponse;
                  afterAdded(response);
                })
                .catch(async () => {
                  if (window.lxRefreshCartUI) await window.lxRefreshCartUI();
                  if (cartDrawer) {
                    if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
                    if (typeof cartDrawer.open === 'function') cartDrawer.open();
                  }
                });
            } else {
              const fallbackDrawer = document.querySelector('cart-drawer');
              if (fallbackDrawer) {
                if (window.lxRefreshCartUI) window.lxRefreshCartUI();
                if (fallbackDrawer.classList.contains('is-empty')) fallbackDrawer.classList.remove('is-empty');
                if (typeof fallbackDrawer.open === 'function') fallbackDrawer.open();
              } else if (window.routes && window.routes.cart_url) {
                window.location = window.routes.cart_url;
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.style.pointerEvents = 'auto';
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// Cache buster
